import React, { useState } from "react"

import { getPermissionConfigs } from "../configs/permissionConfigs"

import { useAuthAccess, authTargetSystemRouteTypes } from "./useAuthAccess"

export const {
    scopeIds,
    scopeTypes,
    functionActionTypes,
    functionTypes,
    permissionConfigs
} = getPermissionConfigs()

const checkValidScopeId = (id) => {

    let checkStatus = false;

    Object.keys(scopeIds).forEach(i => {
        if (scopeIds[i]?.id === id) {
            checkStatus = true
        }
    })

    return checkStatus
}

const checkObjectHasKey = ({ obj, key }) => {

    let valid = false;

    Object.keys(obj).forEach(e1 => {
        if (e1 === key) valid = true
    })

    return valid
}

export function usePermissions(_routeType = '', _scopeId = '', _scopeType = '', _functionType = '') {

    const [routeType, setRouteType] = useState(_routeType)
    const [scopeId, setScopeId] = useState(_scopeId)
    const [scopeType, setScopeType] = useState(_scopeType)
    const [functionType, setFunctionType] = useState(_functionType)

    // const authAccessType = authTargetSystemRouteTypes[_routeType]

    const { getRolePermissions, checkIsOwnerUser } = useAuthAccess()

    const {
        scopeIds,
        scopeTypes,
        functionActionTypes,
        functionTypes,
        permissionConfigs
    } = getPermissionConfigs()

    const checkPermissionAllow = ({ routeType, parentScopeType, parentScopeValue, scopeType, functionType }) => {

        let {
            assignedRoles,
            assignedPermissions
        } = getRolePermissions()

        // console.log('rolePermissions', routeType, parentScopeType, parentScopeValue, scopeType, functionType, assignedPermissions)

        // check parent ScopeType exist
        // if (parentScopeType in assignedPermissions === false) return false

        // // check ScopeType exist
        // if (scopeType in assignedPermissions[parentScopeType] === false) return false

        // let listPermissions = assignedPermissions[parentScopeType][scopeType]

        // check parent ScopeType exist
        if (parentScopeValue in assignedPermissions === false) return false

        // check ScopeType exist
        if (scopeType in assignedPermissions[parentScopeValue] === false) return false

        let listPermissions = assignedPermissions[parentScopeValue][scopeType]

        // console.log('listPermissions', listPermissions, assignedPermissions)

        // check permission is array format
        if (Array.isArray(listPermissions) === false) return false;

        if (listPermissions.includes(functionType)) { // permission is exists
            return true;
        }

        return false;

    }

    const isPermissionAllow = ({
        routeType: overrideRouteType,
        scopeId: overrideScopeId,
        scopeType: overrideScopeType,
        functionType: overrideFunctionType
    }) => {

        let selectRouteType = routeType;
        let selectScopeId = scopeId;
        let selectScopeType = scopeType;
        let selectFunctionType = functionType;

        if (overrideRouteType) selectRouteType = overrideRouteType
        if (overrideScopeId) selectScopeId = overrideScopeId
        if (overrideScopeType) selectScopeType = overrideScopeType
        if (overrideFunctionType) selectFunctionType = overrideFunctionType

        if (!selectRouteType) throw new Error(`Invalid route type in permission`)

        // check the scope type is valid
        // let validScopeKey = false;
        // let validScopeParentName = '';

        // console.log('selectRouteType', selectRouteType, selectScopeId, selectScopeType, selectFunctionType)

        // validScopeParentName =

        // Object.keys(scopeTypes).forEach((e1, index1) => {
        //     let arrayKeys = Object.keys(scopeTypes[e1])

        //     arrayKeys.forEach((e2, index2) => {

        //         if (scopeTypes[e1][e2]?.id === selectScopeType) {
        //             validScopeParentName = e1;
        //             validScopeKey = true
        //         }

        //     })

        // })

        // if (validScopeKey === false) throw new Error(`Invalid scope key : ${selectScopeType}`)

        // check the scope id valid
        if (checkValidScopeId(selectScopeId) === false)
            throw new Error(`Unsupported scope id : ${selectScopeId}`)

        if (checkObjectHasKey({ obj: permissionConfigs[selectScopeId], key: selectScopeType }) === false)
            throw new Error(`Unsupported scope type : ${selectScopeType} (${selectScopeId})`)

        if (checkObjectHasKey({ obj: permissionConfigs[selectScopeId][selectScopeType], key: selectFunctionType }) === false)
            throw new Error(`Unsupported function type : ${selectScopeType} > ${selectFunctionType} (${selectScopeId})`)

        let permissionName = selectFunctionType;
        let permissionStatus;

        // console.log('permissionConfigs[selectScopeId][selectScopeType]', routeType, permissionConfigs[selectScopeId][selectScopeType], selectFunctionType)

        // check routeType exists
        if (checkObjectHasKey({
            obj: permissionConfigs[selectScopeId][selectScopeType][selectFunctionType],
            key: routeType
        })) {

            // system configured has this option 
            permissionStatus = permissionConfigs[selectScopeId][selectScopeType][selectFunctionType][selectRouteType]

            // console.log('permissionStatus', selectScopeId, permissionConfigs[selectScopeId][selectScopeType][selectFunctionType], selectScopeType, selectFunctionType, permissionStatus)

            // need to check the auth access token for permissions for this logged in user
            if (permissionStatus) {

                // console.log('checkIsOwnerUser()', checkIsOwnerUser())

                if (checkIsOwnerUser() === true) {
                    // is owner always all permission open
                    permissionStatus = true
                } else {

                    // get the scope value
                    let _selectedScopes = scopeIds[selectScopeId]

                    // override the permission if the real auth token access allow
                    permissionStatus = checkPermissionAllow({
                        routeType,
                        parentScopeType: selectScopeId,
                        parentScopeValue: _selectedScopes?.value,
                        scopeType: selectScopeType,
                        functionType: selectFunctionType
                    })
                }

            }

        } else {
            permissionStatus = false; // not exists mean no permission
            // throw new Error(`Unsupported permission configs`, permissionConfigs[selectScopeId][selectScopeType][selectFunctionType])
        }

        return permissionStatus

    }

    return {
        // checkPermission, 
        isPermissionAllow,
        functionTypes,
        scopeTypes
    }
}